import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="rounded-2xl bg-primary-50 border border-primary-200 px-6 md:px-12 py-12 md:py-16 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
          {t('final.title')}
        </h2>
        <p className="mt-4 max-w-2xl mx-auto text-sm md:text-base text-foreground-700 leading-relaxed">
          {t('final.desc')}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('final.cta')}
            <span className="flex w-4 h-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}